import { SvgIconBase, } from "./Base";


export const CrossCircle = () => {
	return (
		<SvgIconBase width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-label="Cross Circle" fill="currentColor">
			<title>Cross Circle</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.41663 10.0003C2.41663 5.81217 5.8118 2.41699 9.99996 2.41699C14.1881 2.41699 17.5833 5.81217 17.5833 10.0003C17.5833 14.1885 14.1881 17.5837 9.99996 17.5837C5.8118 17.5837 2.41663 14.1885 2.41663 10.0003ZM9.99996 0.916992C4.98337 0.916992 0.916626 4.98374 0.916626 10.0003C0.916626 15.0169 4.98337 19.0837 9.99996 19.0837C15.0165 19.0837 19.0833 15.0169 19.0833 10.0003C19.0833 4.98374 15.0165 0.916992 9.99996 0.916992ZM8.03029 6.97C7.7374 6.6771 7.26252 6.6771 6.96963 6.97C6.67674 7.26289 6.67674 7.73776 6.96963 8.03066L8.9393 10.0003L6.96963 11.97C6.67674 12.2629 6.67674 12.7378 6.96963 13.0307C7.26252 13.3235 7.7374 13.3235 8.03029 13.0307L9.99996 11.061L11.9696 13.0307C12.2625 13.3235 12.7374 13.3235 13.0303 13.0307C13.3232 12.7378 13.3232 12.2629 13.0303 11.97L11.0606 10.0003L13.0303 8.03066C13.3232 7.73776 13.3232 7.26289 13.0303 6.97C12.7374 6.6771 12.2625 6.6771 11.9696 6.97L9.99996 8.93967L8.03029 6.97Z"
			/>
		</SvgIconBase>
	);
};

